import { Controller } from "@hotwired/stimulus"

// Marge gardée entre le panneau et le bord de la fenêtre : collé au pixel près, il donne
// l'impression d'être coupé.
const MARGIN = 8

// Un menu qui s'ouvre au clic et se ferme au clic extérieur ou à Échap.
//
// Générique : la palette d'ajout de bloc s'en sert, d'autres écrans le reprendront. Il ne
// sait rien de ce qu'il contient.
export default class extends Controller {
  static targets = ["trigger", "panel"]
  // OUVERT DÈS L'ARRIVÉE, quand le serveur le demande. Sert au formulaire qui revient avec son
  // erreur : rendu fermé, il faudrait le rouvrir pour lire ce qui ne va pas. Faux par défaut, donc
  // sans effet sur les menus qui ne le posent pas.
  static values = { open: Boolean }

  connect() {
    this.onOutsideClick = (event) => {
      if (!this.element.contains(event.target)) this.close()
    }
    this.onKeydown = (event) => {
      if (event.key === "Escape") this.close()
    }

    // APRÈS LE RENDU : `open()` mesure la place disponible sous le déclencheur, ce qui suppose que
    // l'élément soit posé dans la page. Au `connect()` d'une réponse Turbo, il ne l'est pas encore.
    if (this.openValue) requestAnimationFrame(() => this.open())
  }

  disconnect() {
    this.#stopListening()
  }

  toggle() {
    this.panelTarget.hidden ? this.open() : this.close()
  }

  open() {
    this.panelTarget.hidden = false
    this.#placeWhereItFits()
    this.triggerTarget.setAttribute("aria-expanded", "true")
    // Écoute posée seulement quand le menu est ouvert : un écran qui en porte dix ne doit
    // pas installer dix écouteurs permanents sur le document.
    document.addEventListener("click", this.onOutsideClick)
    document.addEventListener("keydown", this.onKeydown)
  }

  close() {
    this.panelTarget.hidden = true
    this.triggerTarget.setAttribute("aria-expanded", "false")
    this.#stopListening()
  }

  // LE PANNEAU S'OUVRE DU CÔTÉ OÙ IL Y A LA PLACE.
  //
  // Vers le bas par défaut, vers le haut quand le bas n'en offre pas assez ET que le haut
  // en offre davantage. Un menu qui déborde sous le pli oblige à faire défiler pour
  // atteindre ses dernières entrées — et la palette d'ajout vit précisément en bas de la
  // liste des blocs, donc au plus près du bord.
  //
  // Mesuré à chaque ouverture et non une fois pour toutes : la page défile, et la place
  // disponible n'est pas la même selon l'endroit où l'on se trouve.
  #placeWhereItFits() {
    const trigger = this.triggerTarget.getBoundingClientRect()
    const panel = this.panelTarget.getBoundingClientRect()
    const below = window.innerHeight - trigger.bottom
    const above = trigger.top

    const openUpwards = below < panel.height + MARGIN && above > below
    this.panelTarget.classList.toggle("bottom-full", openUpwards)
    this.panelTarget.classList.toggle("mb-1", openUpwards)
    this.panelTarget.classList.toggle("mt-1", !openUpwards)
  }

  #stopListening() {
    document.removeEventListener("click", this.onOutsideClick)
    document.removeEventListener("keydown", this.onKeydown)
  }
}
